import { CircularProgress, Typography } from '@mui/material';
import FlexBox from '@/components/FlexBox';

const Loading = ({ message = '로딩중입니다' }: { message?: React.ReactNode }) => {
  return (
    <FlexBox
      style={{
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        paddingY: '32px'
      }}
    >
      <Typography variant="h6" color="success">
        {message}
      </Typography>
      <CircularProgress size={32} color="success" />
    </FlexBox>
  );
};

export default Loading;
